import "vuetify/styles";
import { createVuetify } from "vuetify";
import { aliases, mdi } from "vuetify/iconsets/mdi";
import { fr, en } from "vuetify/locale";

try {
  localStorage.removeItem("[object Object]");
} catch { /* ignore */ }

const darkColors = {
  primary: "#4879a7",
  accent: "#b7a6f0",
  secondary: "#ffe18d",
  success: "#4CAF50",
  info: "#f3bb21",
  warning: "#FB8C00",
  error: "#FF5252",
  background: "#262b35",
  surface: "#2f3742",
  neutral: "#b9bec7",
};

const lightColors = {
  primary: "#4879a7",
  accent: "#7c6bd0",
  secondary: "#30b1dc",
  success: "#4CAF50",
  info: "#f3bb21",
  warning: "#FB8C00",
  error: "#FF5252",
  background: "#eef1f4",
  surface: "#f7f8fa",
  neutral: "#262b35",
};

export default createVuetify({
  // Seuils Vuetify 3 conserves (V4 les a reduits) - garder synchro avec $grid-breakpoints dans sass/settings.scss
  display: {
    thresholds: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
      xxl: 2560,
    },
  },
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: { mdi },
  },
  theme: {
    defaultTheme: "dark",
    themes: {
      dark: {
        dark: true,
        colors: darkColors,
      },
      light: {
        dark: false,
        colors: lightColors,
      },
    },
  },
  locale: {
    locale: "fr",
    fallback: "en",
    messages: { fr, en },
  },
  defaults: {
    VBtn: {
      rounded: "pill",
      density: "comfortable",
    },
    VCard: {
      rounded: "md",
    },
    VChip: {
      density: "comfortable",
      size: "small",
    },
    VTextField: {
      variant: "underlined",
      color: "primary",
      density: "compact",
    },
    VTextarea: {
      variant: "underlined",
      color: "primary",
      density: "compact",
    },
    VSelect: {
      variant: "underlined",
      color: "primary",
      density: "compact",
    },
    VAutocomplete: {
      variant: "underlined",
      color: "primary",
      density: "compact",
    },
    VCombobox: {
      variant: "underlined",
      color: "primary",
      density: "compact",
    },
    VFileInput: {
      variant: "underlined",
      color: "primary",
      density: "compact",
    },
    VList: {
      density: "compact",
    },
    VListItem: {
      density: "compact",
    },
    VTabs: {
      density: "comfortable",
    },
    VToolbar: {
      density: "comfortable",
    },
    VAppBar: {
      density: "comfortable",
    },
    VDataTable: {
      density: "compact",
    },
    VCheckbox: {
      density: "compact",
    },
    VRadio: {
      density: "compact",
    },
    VSwitch: {
      density: "compact",
    },
    VPagination: {
      density: "comfortable",
    },
  },
});
